// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6936":"ed602f5d5882de77","9894":"afbb56f5c1cd8e70"}[chunkId] + ".js";
};